import { render, staticRenderFns } from "./MarketPricing.vue?vue&type=template&id=354bad1c&scoped=true"
import script from "./MarketPricing.vue?vue&type=script&lang=js"
export * from "./MarketPricing.vue?vue&type=script&lang=js"
import style0 from "./MarketPricing.vue?vue&type=style&index=0&id=354bad1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354bad1c",
  null
  
)

export default component.exports